import ElasticComponentContext from '@/features/shared/ElasticComponent/ElasticComponentContext';
import { Theme } from '@/utils/constants';
import { orderBy } from 'lodash';
import React, { useCallback, useContext, useState } from 'react';
import useDeepCompareEffect from 'use-deep-compare-effect';
import Button from '../Button';
import { FacetFilters } from '../ElasticComponent';
import FourFiveColumnContent from '../FourFiveColumnContent';
import { MuiPopover, MuiTypography } from '../material-ui';
import useStyles from './Filters.styles';

const FiltersPopover = React.forwardRef(
  (
    {
      theme,
      open,
      anchorEl,
      onClose = () => null,
      onSubmit = () => null,
      isSorted = false,
      config = {},
      facetsSearch = [],
      hasScroll = false,
    }: any,
    ref?: React.Ref<HTMLDivElement>,
  ) => {
    const { facets, forceUpdate = () => null, labels = {} } = useContext(ElasticComponentContext);
    const classes = useStyles({});
    const [allFilters, setAllFilters] = useState<any[]>([]);

    const buildFilterMenu = useCallback(() => {
      return facets
        .filter((filter) => filter.name)
        .map((filter: any) => ({
          ...filter,
          options: isSorted
            ? orderBy(filter.options, [({ value }) => value?.toLowerCase()], ['asc'])
            : filter.options,
        }));
    }, [facets, isSorted]);

    const handleClose = () => {
      onClose();
    };

    const handleApplyFilters = () => {
      onSubmit();
      onClose();
      forceUpdate();
    };

    useDeepCompareEffect(() => {
      const sortedFilters = facets.length ? buildFilterMenu() : [];

      setAllFilters(sortedFilters);
    }, [facets, isSorted]);

    return (
      <MuiPopover
        ref={ref}
        open={open}
        onClose={handleClose}
        anchorEl={anchorEl}
        className={classes.root}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
      >
        <FourFiveColumnContent
          className={classes.columns}
          columnCount={allFilters.length}
          columns={allFilters.map((item) => {
            const categoryLabel = labels[item.name] || item.label;

            return (
              <>
                <MuiTypography variant="h6" className={classes.columnHead}>
                  {categoryLabel}
                </MuiTypography>
                <FacetFilters
                  config={config}
                  categoryLabel={categoryLabel}
                  labels={labels}
                  facet={item.name}
                  options={item.options}
                  theme={Theme.dark}
                  hasSearch={facetsSearch.find((fieldSearch: string) => fieldSearch === item.name)}
                  hasScroll={hasScroll}
                />
              </>
            );
          })}
        />
        <div className={classes.closeAndApply}>
          <Button outlined theme={Theme.dark} onClick={handleApplyFilters}>
            <span>{labels?.close_apply_filters || 'Close & Apply Filters'}</span>
          </Button>
        </div>
      </MuiPopover>
    );
  },
);

export default FiltersPopover;
